import React, { useRef } from 'react'

import PlaceHolderPage from '../PlaceHolderPage'
import PlayerPage from '../PlayerPage'
import { PageWrapperElement } from './Styled'
import { SchemaShortVideoShow } from 'api'

interface PageWrapperProps {
  pageActivated: boolean
  videoInfo: any
  type: string
  imageCache: {
    [id: string]: {
      src: string | null
    }
  }
  updateImageCache: (id: any, src: string | null) => void
  handleAddLikeList: (videoInfo: any) => void
  handleAddCollectList: (videoInfo: any) => void
  preloadedImages: any[]
  autoplay: boolean
  toolbarStyle?: 'default' | 'home'
  onShare?: (video: SchemaShortVideoShow) => void
}

const PageWrapper = ({
  pageActivated,
  videoInfo,
  type,
  imageCache,
  updateImageCache,
  handleAddLikeList,
  handleAddCollectList,
  preloadedImages,
  autoplay,
  // default, home
  toolbarStyle = 'default',
  onShare,
}: PageWrapperProps) => {
  const pageRef = useRef<HTMLDivElement>(null)

  return (
    <PageWrapperElement ref={pageRef}>
      {pageActivated ? (
        type === 'short' ? (
          <PlayerPage
            autoplay={autoplay}
            mode="video"
            videoInfo={videoInfo}
            posterSrc={imageCache[videoInfo.id]?.src}
            onBase64ImageLoad={(src: string | null) => updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)}
            onLike={() => handleAddLikeList(videoInfo)}
            onSave={() => handleAddCollectList(videoInfo)}
            onShare={onShare}
            preloadedImages={preloadedImages}
            toolbarStyle={toolbarStyle}
          />
        ) : (
          <PlayerPage
            autoplay={autoplay}
            mode="promotion"
            promoteInfo={videoInfo}
            posterSrc={imageCache[videoInfo.id]?.src}
            onBase64ImageLoad={(src: string | null) => updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)}
            preloadedImages={preloadedImages}
            toolbarStyle={toolbarStyle}
          />
        )
      ) : (
        <PlaceHolderPage
          videoInfo={videoInfo}
          posterSrc={imageCache[videoInfo.id]?.src}
          onBase64ImageLoad={(src: string | null) => updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)}
          toolbarStyle={toolbarStyle}
          onLike={() => handleAddLikeList(videoInfo)}
          onSave={() => handleAddCollectList(videoInfo)}
          onShare={onShare}
        />
      )}
    </PageWrapperElement>
  )
}

export default PageWrapper
